<div class="outer-container" [class.noClick]="registerNewUserWait">
  <div fxLayout="row" fxLayoutAlign="space-between">
    <!-- <div class="sub-title" *ngIf="!isEdit">Create Account</div>
    <div class="sub-title" *ngIf="isEdit">Edit Account</div> -->

    <div *ngIf="!isEdit" class="reg-steps">
      <app-consumer-curriculum-registration-steps
     [whichStep]="1"
    >
    </app-consumer-curriculum-registration-steps>
    </div>
  </div>
  <div 
  *ngIf="!confirmationEmailSent"
  fxLayout="row" 
  fxLayoutAlign="space-between" 
  class="background-white">
    <div class="row-padded first-row image">
      <img src="{{imagePath}}assets/images/register.png" />
    </div>
    <div class="example-full-width">
      <form
        class="example-form account-form"
        #accountForm="ngForm"
        autocomplete="off"
        (keydown)="EnterSubmit($event, accountForm)"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="row-padded first-row"
        >
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="First Name"
              [(ngModel)]="createAccount.FirstName"
              name="FirstName"
              #FirstName="ngModel"
              required
            />
            <mat-error
              *ngIf="
                FirstName.invalid &&
                (FirstName.dirty || FirstName.touched) &&
                FirstName.errors.required
              "
            >
              First Name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="row-padded"
        >
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Last Name"
              [(ngModel)]="createAccount.LastName"
              name="LastName"
              #LastName="ngModel"
              required
            />
            <mat-error
              *ngIf="
                LastName.invalid &&
                (LastName.dirty || LastName.touched) &&
                LastName.errors.required
              "
            >
              Last Name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="row-padded"
        >
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Email"
              [(ngModel)]="createAccount.Email"
              name="Email"
              #Email="ngModel"
              pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$"
              required
              autocomplete="email"
              (keyup)="search(Email.value, Email)"
            />
            <mat-error
              *ngIf="
                Email.invalid &&
                (Email.dirty || Email.touched) &&
                Email.errors.pattern
              "
            >
              Please enter a valid email address
            </mat-error>
            <mat-error
              *ngIf="
                Email.invalid &&
                (Email.dirty || Email.touched) &&
                Email.errors.required
              "
            >
              Email is required
            </mat-error>
          </mat-form-field>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="row-padded"
        >
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Password"
              [type]="passwordHide ? 'password' : 'text'"
              [(ngModel)]="createAccount.Password"
              name="Password"
              autocomplete="new-password"
              minlength="8" required
              #Password="ngModel"
            />
            <mat-icon matSuffix (click)="passwordHide = !passwordHide">{{
              passwordHide ? "visibility" : "visibility_off"
            }}</mat-icon>
            <mat-error *ngIf="Password.errors && Password.errors.minlength">
              Minimum 8 characters required
            </mat-error>
            <mat-error
              *ngIf="
                Password.invalid &&
                (Password.dirty || Password.touched) &&
                Password.errors.required
              "
            >
              Password is required
            </mat-error>
          </mat-form-field>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="row-padded form-key"
        >
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Confirm Password"
              [type]="confirmPasswordHide ? 'password' : 'text'"
              [(ngModel)]="createAccount.PasswordConfirm"
              name="PasswordConfirm"
              minlength="8" required
              #PasswordConfirm="ngModel"
            />
            <mat-icon
              matSuffix
              (click)="confirmPasswordHide = !confirmPasswordHide"
              >{{
                confirmPasswordHide ? "visibility" : "visibility_off"
              }}</mat-icon
            >
            <mat-error
              *ngIf="
                PasswordConfirm.invalid &&
                (PasswordConfirm.dirty || PasswordConfirm.touched) &&
                PasswordConfirm.errors &&
                PasswordConfirm.errors.minlength
              "
            >
              Minimum 8 characters required
            </mat-error>
            <mat-hint *ngIf="checkPassword(createAccount)" class="mat-error"
              >Passwords does not match</mat-hint
            >

            <mat-error
              *ngIf="
                PasswordConfirm.invalid &&
                (PasswordConfirm.dirty || PasswordConfirm.touched) &&
                PasswordConfirm.errors &&
                PasswordConfirm.errors.required
              "
            >
              Confirm Password is required
            </mat-error>
          </mat-form-field>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="row-padded"
          *ngIf="isEdit"
        >
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Old Password"
              [type]="oldPasswordHide ? 'password' : 'text'"
              [(ngModel)]="createAccount.OldPassword"
              name="OldPassword"
              minlength="8"
              required
              #OldPassword="ngModel"
            />
            <mat-icon matSuffix (click)="oldPasswordHide = !oldPasswordHide">{{
              oldPasswordHide ? "visibility" : "visibility_off"
            }}</mat-icon>
            <mat-error
              *ngIf="OldPassword.errors && OldPassword.errors.minlength"
            >
              Minimum 8 characters required
            </mat-error>
            <mat-error
              *ngIf="
                OldPassword.invalid &&
                (OldPassword.dirty || OldPassword.touched) &&
                OldPassword.errors.required
              "
            >
              Old Password is required
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="button-container row-padded mb-20"
          fxLayout="row"
          fxLayoutAlign="space-around"
        >
          <div>
            <button
              class="primary-button button"
              type="button"
              (click)="
                !isEdit
                  ? CreateAccount(accountForm, createAccount)
                  : EditUser(accountForm, createAccount)
              "
            > 
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div 
  *ngIf="confirmationEmailSent"
  class="mt-50"
  fxLayout="column"
  fxLayoutAlign="center center">

    <div>A confirmation email has been sent. You must confirm your email before going any further. </div> <br><br> <div>Thank you.</div>
  </div>
</div>

<div *ngIf="registerNewUserWait" class="spinner-wrapper">
  <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
</div>
